import React from 'react';
import { Badge } from '../../components/ui/badge';

// Status tones map onto the Badge's semantic variants; everything else is a
// flat secondary badge.
const TONE_VARIANT = {
  green: 'success',
  warn: 'warning',
  error: 'destructive',
};

const PillTag = ({ tone = 'neutral', dot, children, style }) => (
  <Badge variant={TONE_VARIANT[tone] || 'secondary'} style={style}>
    {dot && <span aria-hidden className="ui-badge__dot" />}
    {children}
  </Badge>
);

export default PillTag;
